module.exports = __webpack_public_path__ + "static/media/sqaure.d6a81cdc.svg";